import axios from "axios";
import config from "../config";
import reduxStore from "../redux/store";
import {
  updateLoading,
  showError,
  updateAccessToken,
  logout,
  setNoError,
} from "../redux/actions";
// import { refreshToken } from ".";
import i18n from "../i18n";

const instance = axios.create({
  baseURL: config.apiUrl,
  // timeout: 1000,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": i18n.language === "ar" ? "ar-JO" : "en-US",
  },
});

const requestInterceptor = (request) => {
  if (!request.dontUpdateLoading) {
    reduxStore.dispatch(updateLoading(true));
  }
  if (["/Login/Token"].includes(request.url)) {
    return request;
  }
  const token = localStorage.getItem("accessToken");
  request.headers["Authorization"] = `Bearer ${token}`;
  return request;
};

const responseInterceptor = (response) => {
  if (!response.config.dontUpdateLoading) {
    reduxStore.dispatch(updateLoading(false));
  }
  return response;
};
// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//   failedQueue.forEach((prom) => {
//     if (error) {
//       prom.reject(error);
//     } else {
//       prom.resolve(token);
//     }
//   });

//   failedQueue = [];
// };

const errorHandler = async (error) => {
  if (!error.config?.dontUpdateLoading) {
    reduxStore.dispatch(updateLoading(false));
  }
  const originalConfig = error.config;
  if (
    originalConfig &&
    originalConfig.url !== "/auth/signin" &&
    error.response
  ) {
    // Access Token was expired
    // if (error.response.status === 401 && !originalConfig._retry) {
    //   originalConfig._retry = true;

    //   try {
    //     if (!isRefreshing) {
    //       const refresh_Token = localStorage.getItem("refreshToken");
    //       if (!refresh_Token) {
    //         console.log("Refresh Token not exists");
    //         reduxStore.dispatch(logout());
    //         return;
    //       }
    //       if (!error.config?.dontUpdateLoading) {
    //         reduxStore.dispatch(updateLoading(true));
    //       }
    //       isRefreshing = true;
    //       // const rs = await refreshToken({ refreshToken: refresh_Token });
    //       isRefreshing = false;
    //       // if (rs.data.error) {
    //       //   reduxStore.dispatch(logout());
    //       //   processQueue({ message: rs.data.error_description }, null);
    //       //   return Promise.reject({ message: rs.data.error_description });
    //       // }
    //       // const { access_token } = rs.data;

    //       // processQueue(null, access_token);
    //       // reduxStore.dispatch(updateAccessToken(access_token));
    //       // localStorage.setItem("accessToken", access_token);
    //       // localStorage.setItem("refreshToken", rs.data.refresh_token);
    //       // return instance(originalConfig);
    //     } else {
    //       return new Promise(function (resolve, reject) {
    //         failedQueue.push({ resolve, reject });
    //       })
    //         .then((token) => {
    //           originalConfig.headers["Authorization"] = "Bearer " + token;
    //           return axios(originalConfig);
    //         })
    //         .catch((err) => {
    //           return Promise.reject(err);
    //         });
    //     }
    //   } catch (_error) {
    //     isRefreshing = false;
    //     return Promise.reject(_error);
    //   }
    // } else {
      if (error.response.status === 401) {
        reduxStore.dispatch(logout());
      } else if (error) {
        const { noError } = reduxStore.getState((state) => state);
        if (!noError) {
          if (error.response.data && typeof error.response.data === "string") {
            if (!error.config?.hideToaster) {
              reduxStore.dispatch(showError(error.response.data));
            }
          } else if (error.response?.data?.error_description) {
            if (!error.config?.hideToaster) {
              reduxStore.dispatch(
                showError(error.response.data.error_description)
              );
            }
          } else if (error.message) {
            if (!error.config?.hideToaster) {
              reduxStore.dispatch(showError(i18n.t(error.message)));
            }
          } else {
            reduxStore.dispatch(showError(i18n.t("errors.networkError")));
          }
        }
      } else {
        reduxStore.dispatch(showError(i18n.t("errors.networkError")));
      }

      setTimeout(() => {
        reduxStore.dispatch(showError(""));
        reduxStore.dispatch(setNoError(false));
      }, 1000);
    // }
  } else {
    if (error) {
      if (error.response?.data?.message) {
        if (!error.config?.hideToaster) {
          reduxStore.dispatch(showError(error.response.data.message));
        }
      } else if (error.message) {
        if (!error.config?.hideToaster) {
          reduxStore.dispatch(showError(i18n.t(error.message)));
        }
      } else {
        reduxStore.dispatch(showError(i18n.t("errors.networkError")));
      }
    } else {
      reduxStore.dispatch(showError(i18n.t("errors.networkError")));
    }


  }

  return Promise.reject(error);
};

// Add a request interceptor
instance.interceptors.request.use(requestInterceptor, errorHandler);

// Add a response interceptor
instance.interceptors.response.use(responseInterceptor, errorHandler);

export default instance;
